import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../api";
import LoadingSpinner from "../../../externalComponents/LoadingSpinner";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../externalComponents/tailwind/dropdown";

export default function ContactsActionsDropdown({ customerId, contactId }) {
  const navigate = useNavigate();
  const [actions, setActions] = useState({
    data: null,
    fetchingLastActiveConversationId: null,
  });
  /**
   * Due to performances issues while retrieving the conversations, search the conversation on click.
   */
  const seeConversation = useCallback(
    async ($event) => {
      if (actions.fetchingLastActiveConversationId) {
        return;
      }

      setActions({
        data: null,
        fetchingLastActiveConversationId: true,
      });

      // do not close the menu
      $event.stopPropagation();
      $event.preventDefault();

      const data = await api.conversation.maybeFindFirst({
        filter: {
          customerId: { equals: customerId },
          contactId: { equals: contactId },
          isArchived: { notEquals: true },
        },
        select: {
          id: true,
        },
      });

      setActions({
        data,
        fetchingLastActiveConversationId: false,
      });

      if (!data || !data.id) {
        return;
      }

      navigate(`/conversations/${data.id}`);
    },
    [contactId, actions.fetchingLastActiveConversationId],
  );

  return (
    <Dropdown>
      <DropdownButton plain aria-label="More options">
        <EllipsisHorizontalIcon />
      </DropdownButton>

      <DropdownMenu anchor="bottom end">
        <DropdownItem onClick={seeConversation}>
          {actions.fetchingLastActiveConversationId ? (
            <>
              <div className="w-[25px] h-[25px] overflow-hidden mr-3">
                <LoadingSpinner />
              </div>
              Finding conversation
            </>
          ) : (
            <>
              {actions.fetchingLastActiveConversationId === false
                ? "No conversation"
                : "See conversation"}
            </>
          )}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
